import { render, staticRenderFns } from "./FooterButtonGroup.vue?vue&type=template&id=48798aae&scoped=true"
import script from "./FooterButtonGroup.vue?vue&type=script&lang=js"
export * from "./FooterButtonGroup.vue?vue&type=script&lang=js"
import style0 from "./FooterButtonGroup.vue?vue&type=style&index=0&id=48798aae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48798aae",
  null
  
)

export default component.exports